import { useMemo } from "react";

interface PaginationData {
  totalCount: number;
  pageSize: number;
}

interface PaginationResult {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalCount: number;
  prevPage: number | undefined;
  nextPage: number | undefined;
}

interface UseGetGenericPaginationParams {
  data?: { pagination?: PaginationData };
  currentPage: number;
  pageSize: number;
}

export const useGetGenericPagination = ({
  data,
  currentPage,
  pageSize,
}: UseGetGenericPaginationParams): PaginationResult => {
  const pagination = useMemo(() => {
    if (data?.pagination === undefined) {
      return {
        currentPage,
        totalPages: 1,
        pageSize,
        totalCount: 0,
        prevPage: undefined,
        nextPage: undefined,
      };
    }

    const totalPages = Math.ceil(
      data.pagination.totalCount / data.pagination.pageSize
    );

    return {
      currentPage,
      totalPages,
      pageSize: data.pagination.pageSize,
      totalCount: data.pagination.totalCount,
      prevPage: currentPage === 1 ? undefined : currentPage - 1,
      nextPage: currentPage === totalPages ? undefined : currentPage + 1,
    };
  }, [data, currentPage, pageSize]);

  return pagination;
};
